import { Title } from '@factorialco/deprecated-design-system'

import PanesPadForm from 'modules/core/components/PanesPadForm'
import i18n from 'modules/core/lib/i18n'

import CoffreFortNumeriqueForm from 'modules/coffrefortnumerique/components/Form'
import type { Stateable } from 'modules/coffrefortnumerique/lib/enums'

interface Props {
  id: number
  type: Stateable
}

const CoffreFortNumeriqueBlock = ({ id, type }: Props) => {
  return (
    <PanesPadForm direction="horizontal">
      <Title
        variant="400"
        illustration="money-bag"
        title={i18n.t('settings.edit_company.coffre_fort_numerique_form.title')}
        description={i18n.t('settings.edit_company.coffre_fort_numerique_form.description')}
      />

      <CoffreFortNumeriqueForm id={id} type={type} />
    </PanesPadForm>
  )
}

export default CoffreFortNumeriqueBlock
